import React from "react";
import {ASkeleton, ASkeletonText} from "@cisco-sbg-ui/magna-react";
import css from "./CardSkeleton.module.scss";

const CardSkeleton = () => {
  return (
    <ASkeleton className={css.cardSkeleton} hidePanelBackdrop>
      <ASkeletonText />
      <ASkeletonText />
      <ASkeletonText />
      <ASkeletonText />
      <ASkeletonText />
    </ASkeleton>
  );
};

export default CardSkeleton;
